import { api } from './api';

export interface LogTicketPayload {
  title: string;
  type: 'Bug' | 'Feature' | 'Task' | 'User Story';
  priority: 1 | 2 | 3 | 4;
  description?: string;
  pageUrl: string;
  elementLabel: string;
  screenshotBase64?: string;
  reportedBy: string;
}

export interface LogTicketResult {
  adoId: number;
  adoUrl: string;
}

export async function logTicket(payload: LogTicketPayload): Promise<LogTicketResult> {
  const { data } = await api.post<LogTicketResult>('/api/tickets', payload);
  return data;
}
